import React from 'react'
import {Text, View, StyleSheet} from '../react-native'

import { Button } from './../components'
import { withRouter } from 'react-router-dom'

const HomeScreen = ({ history }) => {
  const { containerStyle, headerStyle, descriptionStyle, callToActionStyle } = styles
  
  return (
    <View style={containerStyle}>
      <Text style={headerStyle}>Welcome to the My Town Trivia Challenge!</Text>
      <img src="http://www.broomearts.org/wp-content/uploads/2012/10/Untitled-1-658x388.jpg" />
      <Text style={descriptionStyle}>You will be presented with 10 Multiple Choice questions</Text>
      <Text style={callToActionStyle}>Can you score 100%?</Text>
      <Button label='BEGIN' onPress={() => history.push(('Name'))}/>
    </View>
  )
}

export default withRouter(HomeScreen)

const styles = StyleSheet.create(
  {
    containerStyle: {
      flex: 1,
      justifyContent: 'space-around',
      backgroundColor: '#A2E4F9',
      width: '100%',
      alignItems: 'center',
      height: '100vh',
      padding: 20,
    },
    headerStyle: {
      color: 'black',
      fontSize: 40,
      fontWeight: 'bold',
      textAlign: 'center'
    },
    descriptionStyle: {
      color: 'black',
      fontSize: 30,
      textAlign: 'center'
    },
    callToActionStyle: {
      color: 'black',
      fontSize:30,
    },
  }
)



// WEBPACK FOOTER //
// ./src/screens/HomeScreen.js